import * as React from 'react';
import cs from 'classnames';
import { FieldError, fieldHoc } from '../../Other';
import { prefixCls } from '../../utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const Ui = props => {
  const {
    children,
    error
  } = props;
  return /*#__PURE__*/_jsxs("div", {
    className: cs(`${prefixCls}-table-field`, {
      'ant-form-item-has-error': !!error
    }),
    children: [children, /*#__PURE__*/_jsx(FieldError, {
      error: error
    })]
  });
};

export const TableField = fieldHoc(Ui);
//# sourceMappingURL=es/components/Table/TableField.js.map